import { createContext } from 'react';
export const TrackerContext = /*#__PURE__*/createContext({
  trackInteraction(interaction, additionalProperties) {
    console.log(`Tracker not set up for tracking interaction`, {
      interaction,
      additionalProperties
    });
  },

  trackPageview(screen, additionalProperties) {
    console.log(`Tracker not set up for tracking pageview`, {
      screen,
      additionalProperties
    });
  }

});